import {applySnapshot, types as t,} from 'mobx-state-tree';

export const initialAuthStore = {
    token: null,
    refresh: null,
    paid: null,
    data: null,
    id: null,
    documentId: null,
    widgets: [],
};

export const AuthStore = t
    .model({
        token: t.maybeNull(t.string),
        id: t.maybeNull(t.string),
        documentId: t.maybeNull(t.string),
        refresh: t.maybeNull(t.boolean),
        paid: t.maybeNull(t.boolean),
        data: t.maybeNull(t.model({
            username: t.maybeNull(t.string),
            email: t.maybeNull(t.string),
            FIO: t.maybeNull(t.string),
            birthdate: t.maybeNull(t.string),
            gender: t.maybeNull(t.string),
            avatar: t.maybeNull(t.string),
        })),
        widgets: t.array(t.maybeNull(t.model({
            identifier: t.maybeNull(t.string),
            content: t.maybeNull(t.array(t.string)),
        }))),
    })
    .views((self => ({
        get hasAuthToken() {
            return !!self.token;
        },
        get hasAnketData():boolean {
            return (!!self.data && (!!self.data.FIO && !!self.data.birthdate && !!self.data.gender))
        },
    })))
    .actions((self) => ({
        clearState: () => {
            applySnapshot(self, initialAuthStore);
        },
        setToken: (token: string | null) => {
            self.token = token;
        },
        setData: (id: string, documentId:string, data: any, paid: boolean) => {
            self.data = data;
            self.paid = paid;
            self.id = id;
            self.documentId = documentId;
        },
        setWidgets: (widgets: Array<any>) => {
            // @ts-ignore
            self.widgets = widgets;
        },
        setRefresh: (value: boolean) => {
            self.refresh = value
        },
        needUpdate() {
            self.refresh = true;
        },

    }));
